'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css3 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 发货按钮及弹出表单：快递物流
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;

var ShipExpress = _react2.default.createClass({
    displayName: 'ShipExpress',
    onOk: function onOk(form) {
        this.props.onSubmit(form.getFieldsValue());
    },
    render: function render() {
        var _props = this.props,
            order = _props.order,
            couriers = _props.couriers,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), title: '\u53D1\u8D27' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u53D1\u8D27\u65B9\u5F0F' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        order.ship.type || '快递物流'
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u5FEB\u9012\u516C\u53F8' }),
                    getFieldDecorator('courier', {
                        rules: [{ required: true, message: '请选择快递公司!' }]
                    })(_react2.default.createElement(
                        _select2.default,
                        { placeholder: '\u8BF7\u9009\u62E9\u5FEB\u9012\u516C\u53F8' },
                        couriers.map(function (x) {
                            return _react2.default.createElement(
                                Option,
                                { key: x.id, value: x.code },
                                x.name
                            );
                        })
                    ))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u5FEB\u9012\u5355\u53F7' }),
                    getFieldDecorator('number', {
                        rules: [{ required: true, message: '请输入快递单号!' }]
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(ShipExpress);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/ship_express.js
// module id = 1315
// module chunks = 0